import React from 'react';

export default class  Page6 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">Some ideas to raise morale and
                                                    get you started
                                                </div>
                                                <ul className="greenbullet-list">
                                                    <li><span
                                                        className="subtiltereg">Get out of the office</span> If
                                                        you work in an office with nice outdoor surroundings,
                                                        and it’s good weather, maybe take an informal meeting
                                                        outside!
                                                    </li>
                                                    <li><span
                                                        className="subtiltereg">Lighten up your emails</span> If
                                                        someone has good news or comes up with a good joke, and
                                                        it’s appropriate to share it, feel free to let others
                                                        join in the fun!
                                                    </li>
                                                    <li><span className="subtiltereg">Make the most of your office</span> If
                                                        you have a communal area, try to make it more appealing
                                                        by providing newspapers, fruit or games in order to
                                                        provide a relaxing and pleasant area in the office for
                                                        those difficult days.
                                                    </li>
                                                    <li><span className="subtiltereg">It doesn’t all have to be hard work!</span> Introducing
                                                        a fun non-work activity such as an indoor sport or video
                                                        games can provide a welcome break from normal work.
                                                    </li>
                                                    <li><span
                                                        className="subtiltereg">Play with the dress code</span> If
                                                        office regulations allow, hold a themed-dress day for
                                                        charity, or a regular day for informal wear.
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">POSITIVE THINKING EXERCISE</span>
                                            </div>
                                            <div className="border_subtitle">Three Blessings and Sweet Dreams<a
                                                className="superscripttext"
                                                href="further_info.php?course=300"><sup>10</sup></a></div>
                                            <p>This exercise is designed to instil a more positive attitude and
                                                greater awareness of what’s ‘good’, rather than ‘bad’.</p>
                                            <p>Many of us seem predisposed, or ‘hard wired’ to analyse our own
                                                and others’ mistakes and failures, rather than celebrate the
                                                positives. While this may help us learn and improve it can just
                                                as easily be counterproductive, through increasing anxiety,
                                                inhibiting creativity and generally undermining our enjoyment of
                                                life.</p>
                                            <p>However, with a little effort and practice, we can recalibrate
                                                our attitude. Thoughts tend to build on and from each other.
                                                There could be much in your day that’s ‘good’, but if you fixate
                                                on the few elements which displease you, you’ll soon convince
                                                yourself that it’s all bad. You can just as easily persuade
                                                yourself into a positive ‘train of thought’ – one thought at a
                                                time. It gets easier the more you do it, and it feels a whole
                                                lot better than the other thing!</p>
                                            <p><span className="subtiltereg">What to do</span></p>
                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">Write</div>
                                                <p>Every night for the next two weeks, write down 3 things that
                                                    went well each day. It doesn’t matter how insignificant you
                                                    think these might sound to anyone else. For example: ‘My
                                                    partner picked up my favourite ice cream on his way home’
                                                    or, much more important: ‘My sister gave birth to a healthy
                                                    baby boy’.</p>
                                            </div>
                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">Explain</div>
                                                <p>Next to each item on your list, write a possible reason for
                                                    it. For example, ‘because my husband is really thoughtful
                                                    sometimes’ or ‘because I remembered to phone him and ask him
                                                    to bring it’.</p>
                                            </div>
                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">Dream</div>
                                                <p>After completing your list and explanations, select one event
                                                    you’d like to dream about. Positive dreams are thought to
                                                    increase general wellbeing and consolidate good memories, so
                                                    it’s worth trying to influence them.</p>

                                            </div>

                                            <div className="left-btn"><div
                                                onClick={this.props.handleChangePage('Page5')}
                                                className="button-next-previous-done">&lt;&lt; Previous </div></div>
                                            <div className="right-btn"><div  onClick={this.props.handleChangePage('Page7')}
                                                                          className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}